const e = { aria_label: "Rechercher", clear: "Effacer", placeholder_article: " ", placeholder_header: "Rechercher des articles" }, r = {
  searcher: e
};
export {
  r as default,
  e as searcher
};
//# sourceMappingURL=help-center-articles-search38.js.map
